export default {
  backToSearch: 'Volver al inicio',
  showMore: 'Ver más',
  weFind: 'Encontramos ',
  educationalPrograms: '{n} programa educativo | {n} programas educativos',
  yourSearch: ' en tu búsqueda',
  errors: {
    noResult: '¡Oh no! No se encontraron resultados para tu búsqueda',
    emptySearchResultExplanation: 'Parece no haber un programa que cumpla con las condiciones de búsqueda, ¡intenta probar algo nuevo   !'
  }
}

export const en = {
  backToSearch: 'Go back',
  showMore: 'Show more',
  weFind: 'We\'ve found ',
  educationalPrograms: '{n} educational program | {n} educational programs',
  yourSearch: ' for your search',
  errors: {
    noResult: 'Oh no! No results found for your search',
    emptySearchResultExplanation: 'No programs seems to match your search criteria, try something new!'
  }
}

export const ca = {
  backToSearch: 'Torna a l\'inici',
  showMore: 'Ensenya\'m més',
  weFind: 'Hem trobat ',
  educationalPrograms: '{n} programa educatiu | {n} programes educatius',
  yourSearch: ' a la teva cerca',
  errors: {
    noResult: 'Vaja! La teva cerca no ha donat resultats',
    emptySearchResultExplanation: 'No sembla haver-hi cap programes que compleixi amb les condicions de cerca, intenta provar una altra cosa.'
  }
}
